module.exports = __webpack_public_path__ + "img/amy.f4c616cb.png";